<template>
  <div class="modal-wrap">
    <el-dialog
      :title="type === 'title' ? '批量添加标题' : '批量添加描述'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="700px"
      :append-to-body="true"
    >
      <div class="modal-body">
        <el-input
          style="margin-top: 8px"
          resize="none"
          type="textarea"
          :rows="10"
          placeholder="请输入，换行增加一个标题/描述，最多5行，5行之后自动截断，每个限制30字"
          v-model="titleText"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchImport">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AddModal",
  data() {
    return {
      dialogVisible: false,
      titleText: "",
      type: "",
      curLength: 5, //当前可以添加的标题数
    };
  },
  methods: {
    showModal(type) {
      this.type = type;
      this.titleText = "";
      this.dialogVisible = true;
    },
    batchImport() {
      const arr = this.titleText
        .split("\n")
        .filter((item) => item.trim())
        .splice(0, 5);
      this.$emit("selectOk", arr, this.type);
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.tip-text {
  display: inline-block;
  margin-top: 6px;
  color: #999;
}
</style>
